import { Grid, Typography, Button, Box, Divider } from '@mui/material'
import { ChatBubbleOutlineOutlined, FmdGoodOutlined, WorkspacePremiumOutlined } from '@mui/icons-material';
import { toPascalCase } from '../../../../../Utils/String';
import { useAppSelector } from '../../../../../Redux/store';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetClientQuery } from '../../../../../Redux/api/clientApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { KaziAvatar } from '../../../../../Shared Components/Kazi/KaziAvatar';
import { ClientProfileSkeleton } from '../ClientProfileSkeleton';
import { useGetManyJobsQuery } from '../../../../../Redux/api/jobApi';
import moment from 'moment';
import { KaziBookmark } from '../../../../../Shared Components/Kazi/KaziBookmark';
import { Client } from '../../../../../Types/Client';
import { Dispatch, SetStateAction } from 'react';
import { useMobileView } from '../../../../../Hooks/useMobileView';

interface IViewClientProfileProps {
    clientData: Client;
    mode: 'view' | 'edit';
    setMode: Dispatch<SetStateAction<'view' | 'edit'>>;
}
export const ViewClientProfile = ({clientData, mode, setMode}: IViewClientProfileProps) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const userId = useAppSelector( state => state.Global.userId);
    const userType = useAppSelector( state => state.Global.userType);
    const {data: jobData, isLoading: jobDataLoading, isFetching: jobDataFetching} = useGetManyJobsQuery(clientData?.posted_jobs || skipToken); 
    const { isMobileView } = useMobileView();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid container display={"flex"} flexDirection={"row"} sx={{color: 'primary.main'}} columnGap={15}>
                <Grid item flex={1} display={"flex"} flexDirection={"column"} gap={4}>
                    <Grid item display={"flex"} flexDirection={"row"} gap={4}>    
                        <Grid display={"flex" } flexDirection='column' justifyContent={'center'} gap={4}>                
                            <KaziAvatar 
                                locator={clientData?.locator ?? ''} 
                                first_name={clientData?.first_name ?? 'N/A'} 
                                last_name={clientData?.last_name} 
                                sx={{alignSelf: 'center', fontSize: 50}} 
                            />
                            {
                                isMobileView &&
                                <Button variant={'contained'} size='large' onClick={() => setMode('edit')}>Edit</Button>
                            }

                        </Grid>
                        <Grid item display={"flex"} flexDirection={"column"} gap={'16px'}>
                            <Typography variant='lora-headline-small' fontWeight={"bold"}>
                                {`${toPascalCase(clientData?.first_name ?? "") } ${clientData?.last_name?.substring(0,1)?.toUpperCase()}.`}
                            </Typography>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <WorkspacePremiumOutlined />
                                <Typography variant='title-small'>{clientData?.company ?? "N/A"}</Typography>
                            </Grid>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <FmdGoodOutlined />
                                <Typography variant='title-small'>{clientData?.country ?? "N/A"}</Typography>
                            </Grid>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <ChatBubbleOutlineOutlined />
                                <Typography variant='title-small'>{clientData?.languages.join(',')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"column"} >
                        <Typography variant='lora-title-medium' fontWeight={"bold"} marginBottom={'16px'}>About</Typography>
                        <Typography>{clientData?.description}</Typography>
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"column"} >
                        {(jobData?.length ?? 0) > 0 && <Typography variant='lora-title-medium' fontWeight={"bold"}>Open Jobs</Typography>}
                        <Grid margin={0} padding={1} sx={{ overflowY: 'auto', maxHeight: '300px'}}>
                            {
                                jobData?.map((job, idx) =>(
                                    <>
                                        {idx > 0 && <Divider />}
                                        <Grid key={`${job.title}-${idx}`} display={"flex"} flexDirection={"row"} paddingY={"16px"} >
                                            <Grid display={"flex"} flexDirection={"column"} gap={"4px"}>
                                                <Typography variant='body-medium'>{job.title}</Typography>
                                                <Typography variant='body-medium' color={'black.200'}>Posted on {moment(job.posting_date).format('MMM DD, YYYY')}</Typography>
                                                <Typography variant='label-small' color={'black.300'}>{job.applicants.length} applicants</Typography>
                                            </Grid>
                                            {
                                                clientData?.locator === userId ?
                                                <Grid display={"flex"} flexDirection={"row"} flex={1} alignItems={"center"} justifyContent={"flex-end"}>
                                                    <Button variant={'outlined'} size='large' onClick={()=> navigate(`/job-postings/posting/${job.locator}/edit`)}>Edit</Button>
                                                </Grid> :
                                                <Grid display={"flex"} flexDirection={"row"} flex={1} alignItems={"center"} justifyContent={"flex-end"}>
                                                    <Button variant={'outlined'} size='large' onClick={()=> navigate(`/marketplace/posting/${job.locator}`)}>View</Button>
                                                </Grid>
                                            }
                                        </Grid>
                                    </>
                                ))
                            }
                        </Grid>
                    </Grid>
                </Grid>
                {!isMobileView && 
                <Grid item flex={1} display={"flex"} flexDirection={"column"} gap={4}>
                    {
                        clientData?.locator === userId ?
                        <Grid item display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} marginBottom={18}>
                            <Button variant={'contained'} size='large' onClick={() => setMode('edit')}>Edit</Button>
                        </Grid> :
                        (   
                            userType === 'talent' ? 
                                <Grid item display={'flex'} flexDirection={'row'} justifyContent={'center'} marginBottom={18}>
                                    <KaziBookmark locator={clientData?.locator ?? ''} /> 
                                </Grid>
                            : null
                        )
                    }
                </Grid>}
            </Grid>
        </>
    )
}